import { Component, OnDestroy, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { interval, Subscription, take } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { SecondsPipe } from '@app/pipes/seconds.pipe';

@Component({
    selector: 'app-invalid-modelations-dialog',
    templateUrl: './throttle-dialog.component.html',
    imports: [MatDialogModule, MatButtonModule, SecondsPipe],
})
export class ThrottleDialogComponent implements OnDestroy {
    dialogRef = inject<MatDialogRef<ThrottleDialogComponent>>(MatDialogRef);

    seconds = 60;
    data: { country?: string; phone?: string } = {};

    private subscription: Subscription | null = null;

    constructor() {
        this.startCountdown();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    startCountdown() {
        this.subscription = interval(1000)
            .pipe(take(this.seconds))
            .subscribe({
                next: () => {
                    this.seconds--;
                },
            });
    }

    closeDialog() {
        this.dialogRef.close(false);
    }

    submitDialog() {
        this.dialogRef.close(true);
    }
}
